<template>
    <div>
        <alert v-if="message"
            :messages="[message]"
            type="ok"
        />

        <alert v-if="status"
            :messages="[status]"
            type="ok"
        />

        <alert v-if="error"
            :messages="[error]"
            type="error"
        />

        <alert v-if="errors.length"
            :messages="errors"
            type="error"
        />
    </div>
</template>

<script>
import Alert from './alert.vue';

export default {
    components: {
        Alert,
    },

    props: {
        message: {},
        status: {},
        error: {},
        errors: {},
    },
}
</script>
